module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/franchising-doveit.6ea89ad7bf3861070e6b753e2e7c2fa8.jpg";